import React, { useState } from 'react'
import { Novelty, RealEstateDataPageComponentData } from 'types'
import { useGetBlogsQuery } from '@apis/mediacore/blog'
import { useSelector } from 'react-redux'
import { Col, Container, Row } from 'react-bootstrap'

const Grid_Novelties_2 = (props: RealEstateDataPageComponentData) => {
  const { global_data, backgroundColor } = props

  const siteId = global_data.id

  const noveltyCard = global_data.content?.cardsNovelties?.type_id ?? '1'
  const { novelties_active } = useSelector(
    (state: { novelties: { tags_active: number[]; novelties_active: Novelty[] } }) =>
      state.novelties,
  )!

  const [visibleNovelties, setVisibleNovelties] = useState(4)

  const handleLoadMore = () => {
    setVisibleNovelties((prev) => prev + 4)
  }

  const hasMoreNovelties = novelties_active?.length > visibleNovelties

  const Card = require(`@components/cardsNovelties/${noveltyCard}`)?.default

  const { data: allBlogData, isLoading } = useGetBlogsQuery({ site: siteId })

  return (
    <section
      id="grid-novelties"
      className={'grid_novelties b'}
      style={backgroundColor ? { backgroundColor: backgroundColor } : {}}
    >
      <Container fluid>
        <Row>
          {novelties_active?.length < 0 && (
            <Col
              xs={12}
              className={'d-flex flex-wrap justify-content-center w-100'}
            >
              <h5 className="text-center mb-5">No hay resultados para esta busqueda</h5>
            </Col>
          )}
          <Row>
            {isLoading
              ? [1, 2, 3].map((index) => (
                  <Card
                    key={index}
                    skeleton={true}
                    global_data={global_data}
                  />
                ))
              : novelties_active
                  .slice(0, visibleNovelties)
                  .map((novelty: Novelty, index: number) => (
                    <Col lg={12}>
                      <Card
                        key={index}
                        tags={allBlogData?.tags}
                        novelty={novelty}
                        hidenTags={true}
                        hidenAuthor={true}
                        global_data={global_data}
                      />
                    </Col>
                  ))}
          </Row>
          <Row className="d-flex justify-content-center mt-5">
            {hasMoreNovelties && (
              <Row className="d-flex justify-content-center mt-5">
                <button
                  className={'btn btn-primary border w-auto'}
                  onClick={handleLoadMore}
                >
                  CARGAR MÁS NOVEDADES
                </button>
              </Row>
            )}{' '}
          </Row>
        </Row>
      </Container>
    </section>
  )
}

export default Grid_Novelties_2
